/*
 * The eleven locales the kit ships with, in the order they appear in the language menu.
 *
 * Translations themselves are fetched at runtime from /locales/<code>.json, so adding a
 * locale means adding a file there and an entry here.
 */

export const LANGUAGES = [
  { label: "Bahasa", code: "id" },
  { label: "DEUTSCH", code: "de" },
  { label: "Eesti", code: "et" },
  { label: "ENG", code: "en" },
  { label: "Español", code: "es" },
  { label: "Latviešu", code: "lv" },
  { label: "Lietuvių", code: "lt" },
  { label: "русский", code: "ru" },
  { label: "عربي", code: "ar" },
  { label: "हिन्दी", code: "hi" },
  { label: "ไทย", code: "th" },
];
